'use strict';

if (!window.i18n) {
    window.i18n = {};
}

if (!window.i18n.languages) {
    window.i18n.languages = {};
}

window.i18n.languages['vi_VI'] = {
	optional:"Không bắt buộc",
	needBet: "Vẫn cần đặt cược:",
	needDeposit:"Vẫn cần đặt cọc:",
	agentCode : "Mã mời",
	tips_fail:"Xác nhận không thành công",
	a_stautss: "trạng thái hoạt động",
	activityDetails_hdjxz: "Hoạt động đang diễn ra",
	activityDetails_hdwks: "Hoạt động chưa bắt đầu",
	activityDetails_hdyjs: "hoạt dộng đã kết thúc",
	a_time: `Thời gian hoạt động`,
	a_status: `Trạng thái hoạt động`,
	a_rule: `Quy tắc phần thưởng`,
	a_content: `Chi tiết hoạt động`,


	gameCoin:"Tiền tệ trò chơi",
	register_chooseCurrency: "Chọn loại tiền gửi",
	register_tips0:"*Không được phép thay đổi tiền tệ sau khi đăng ký",
	register_curInstruction:"Mô tả tiền tệ:",
	register_tips1:"1. Khi tham gia trò chơi không hỗ trợ đơn vị tiền tệ hiện tại của người dùng,Số tiền quy đổi theo tỷ giá hối đoái sẽ được đưa vào trò chơi;",
	register_tips2:"2. Phương thức gửi / rút tiền của người dùng là hiển thị hỗ trợ tiền tệ hiện tại của người dùng;",

	sendSuccess:"Gửi thành công!",
	login_areaCode: 'mã quốc gia',
	login_selectAreaCode: 'Chọn quốc gia hoặc khu vực',
	new_maxVipLV: 'Xin chúc mừng! ! Bạn hiện đang ở cấp cao nhất',
	currency_symbol : "₫",
	language : "TiếngViệt",

	new_r_rate: 'Số tiền đưa vào trò chơi là số tiền sau khi chuyển đổi tỷ giá hối đoái',
	new_r_rate1: 'tỷ giá：',
	new_r_money: 'Tiền trong trò chơi：',
	new_r_tips6: '*Xin lưu ý rằng việc chuyển sang trò chơi ba bên chỉ có thể mang lại số nguyên',
	new_r_tips7: 'Nhắc nhở tỷ giá hối đoái',
	new_r_tips8: 'tôi biết',
	new_r_tips9: 'Bạn hiện đang nhập',
	new_r_game: "trò chơi",


	"ActivityNew": {
	"btn_lingqu": "lấy nó ngay bây giờ",
	"btn_back": "trở về",
	"toggle_zonghe": "Các hoạt động toàn diện"
	},
	"SignIn": {
		"btnLingqu": "nhận được"
	},
	"label_text": {
		"loading_msg": "đang tải msg mới cho bạn",
		"not_logged": "chưa đăng nhập",
		"password": "mật khẩu：",
		"verify": "mã xác nhận：",
		"verify_msg": "vui lòng nhập mã xác nhận",
		"inPlease_enter_the": "vui lòng nhập",
		"phone": "Điện thoại di động",
		"No": "Số",
		"determine": "Xác nhận",
		"receive": "Lĩnh",
		"Image_preview": "Xem trước hình đại diện",
		"Install": "cài đặt ngay",
		"obtain": "chúc mừng bạn nhận được",
		"check_update": "đang kiểm tra cập nhật...",
		"real_name": "họ và tên thật",
		"tips": "ngăn chặn game xấu, cự tuyệt game lậu. Chú ý tự bảo vệ mình, đề phòng bị mắc lừa. Game vừa phải có lợi cho não, nghiện game tổn hại sức khỏe. Sắp xếp thời gian hợp lý, tận hưởng một cuộc sống lành mạnh",
		"no_data": "Tạm thời không có dữ liệu",
		"queding": "Xác Nhận",
		"quxiao": "hủy",
		"online_kefu": " Dịch vụ trực tuyến",
		"title": "Kiếm phần thưởng",
		"tishi": "lời nhắc",
		"download_new_version": "Vui lòng tải xuống phiên bản mới nhất của ứng dụng để sử dụng tính năng này",
		"save_account": "Lưu thông tin tài khoản"
	},
	"data_req_text": {
		"login_failure": "đăng nhập thất bại，vui lòng đăng nhập lại"
	},
	"login_text": {
		"account_pro": "Tài khoản không được để trống, vui lòng điền vào！",
		"psw_pro": "mật khẩu không được để trống, vui lòng điền vào！",
		"vfy_pro": "Mã xác nhận không được để trống, vui lòng điền vào！",
		"quick_login_fail": "Đăng nhập nhanh không thành công！",
		"account": "Tài khoản：",
		"account_msg": "Vui lòng nhập số tài khoản/số điện thoại",
		"paw_msg": "Vui lòng nhập mật khẩu",
		"Remember_acc": "Ghi nhớ số tài khoản",
		"forget_paw": "quên mật khẩu？",
		"no_acc": "Không có tài khoản,",
		"go_reg": "Đi đăng ký>",
		"confirm_login": "Xác nhận đăng nhập",
		"quick_login": "Đăng nhập nhanh",
		"confirm_register": "Xác nhận đăng kí",
		"register_cg": "đăng ký thành công",
		"account_data": "Thông tin tài khoản",
        "sfyz": "Chính xác",
        "sfyz_tip": "Khách hàng thân mến!Để bảo vệ an ninh tài khoản của bạn, việc đăng nhập này cần phải được kiểm tra sau để ngăn chặn những chương trình gây tác hại tự động đăng nhập vào.",
        "bind_bank": "Xin hãy nhập thẻ ngân hàng bị ràng buộc.",
        "bind_alipay": "Hãy nhập vào lề đường",
        "bank_card": "Thẻ ngân hàng:",
        "alipay": "Thanh:",
        "code": "Mật khẩu:",
        "enter_bank_card": "Nhập thẻ ngân hàng",
        "enter_alipay": "Hãy nhập số tài khoản Alipay",
        "enter_code": "Hãy nhập mật mã kiểm tra",
	},
	"register_text": {
		"perfect_suc": "hoàn thiện thông tin thành công！",
		"perfect_err": "hoàn thiện thông tin thất bại！",
		"inp_data": "vui lòng nhập tài liệu trước！",
		"inp_email": "vui lòng nhập hòm thư",
		"inp_phone": "vui lòng nhập số điện thoại",
		"inp_wx": "vui lòng nhập số wechat",
		"inp_qq": "vui lòng nhập số QQ",
		"email": "Hòm thư：",
		"wx_No": "Wechat：",
		"qq_No": "Số QQ：",
		"phone": "Số điện thoại：",
		"user_name": "Tên người dùng:",
		"user_msg": "Nhập tài khoản chữ cái hoặc số có 6-12 chữ số",
		"user_pro": "mật khẩu gồm 6-12 chữ cái hoặc số hoặc ký hiệu",
		"paw_pro": "Mật khẩu là tổ hợp của 6-12 chữ số và chữ cái",
		"confirm_paw_pro": "Xác nhận mật khẩu không được để trống, vui lòng điền vào！",
		"paw_consistent": "Mật khẩu và xác nhận mật khẩu không nhất quán, vui lòng điền lại！",
		"paw_msg": "vui lòng nhập mật khẩu 6-12 chữ số và chữ cái",
		"confirm_msg": "Vui lòng xác nhận lại mật khẩu",
		"phone_msg": "Vui lòng nhập mã xác minh điện thoại",
		"con_paw": "Xác nhận mật khẩu：",
		"exi_acc": "đã có tài khoản，",
		"go_log": "Đi đăng nhập>",
		"send_verify": "Gửi",
		"retry_verify": "Gửi lại",
		"phone_confirm": "Nhập số điện thoại chính xác！",
		"register_suc": "Đăng ký thành công！",
		"user_not_mag": "Tên người dùng không được để trống, vui lòng điền vào！",
		"No_null": "Số không được để trống, vui lòng điền vào！",
		"correct_phone": "Nhập số điện thoại chính xác！",
		"phone_vfy": "Mã xác minh điện thoại không được để trống, vui lòng điền vào！",
		"loss_account": "Để tránh mất tài khoản, vui lòng lưu tài khoản",
		"account_change": "Tài khoản chỉ có thể được sửa đổi một lần, nhấp vào sửa đổi",
		"please_tick": "Vui lòng nhấp vào nút đánh dấu để xác nhận mật khẩu tài khoản trước！",
		"save_suc": "Đã lưu thành công！",
		"save_err": "Lưu không thành công！Vui lòng chụp ảnh màn hình theo cách thủ công!",

		"currency": "Tiền:",
		"language": "Ngôn:",
	},
	"datum_text": {
		"datum_title": "Gửi thông tin",
		"bank_card": "Số thẻ ngân hàng：",
		"inPlease_enter_the": "Vui lòng nhập...",
		"input_datum": "Vui lòng nhập thông tin trước",
		"update_img": "Tải lên hình ảnh",
		"select_update_img": "Vui lòng chọn hình ảnh tải lên",
		"limit_type": "Chỉ có thể tải lên JPG、JPEG、PNG",
		"msg_update_data": "Vui lòng tải lên dữ liệu trước",
		"mag_update_pic": "Vui lòng tải lên hình ảnh ở quy cách chính xác trước",
		"apply_succ": "Gửi yêu cầu thành công, vui lòng chờ xét duyệt"
	},
	"task_text": {
		"activity": "Giảm giá",
		"task": "Nhiệm vụ",
		"announcement": "Thông báo",
		"sign": "Đánh dấu danh",
		"task_name": "tên nhiệm vụ：",
		"task_detail": "Chi tiết nhiệm vụ",
		"task_time": "thời gian nhiệm vụ có hiệu lực：",
		"task_content": "nội dung nhiệm vụ："
	},
	"customer_text": {
		"jump_whatsapp": "Tài khoản whatsapp được sao chép thành công, yêu cầu chuyển đến whatsapp",
		"jump_telegram": "Tài khoản telegram được sao chép thành công, yêu cầu chuyển đến telegram",
		"jump_Messenger": "Tài khoản Messenger được sao chép thành công, yêu cầu chuyển đến Messenger",
		"jump_Viber": "Tài khoản Viber được sao chép thành công, yêu cầu chuyển đến Viber",
		"no_whatsapp": "Thiết bị của bạn chưa được cài đặt whatsapp",
		"no_telegram": "Thiết bị của bạn chưa được cài đặt telegram",
		"no_Messenger": "Thiết bị của bạn chưa được cài đặt Messenger",
		"no_Viber": "Thiết bị của bạn chưa được cài đặt Viber",

		"contact_customer": "liên hệ với dịch vụ khách hàng",
		"not_ind_qq": "Thiết bị của bạn chưa được cài đặt QQ",
		"jump_wx": "Tài khoản WeChat được sao chép thành công, yêu cầu chuyển đến WeChat",
		"not_ind_wx": "Thiết bị của bạn chưa được cài đặt WeChat",
		"jump_mt": "Tài khoản dịch vụ khách hàng MT được sao chép thành công, yêu cầu chuyển đến dịch vụ khách hàng MT",
		"Online": "dịch vụ khách hành trực tuyến",
		"QQ": "dịch vụ khách hàng QQ",
		"WECHAT": "Dịch vụ khách hàng WeChat",
		"MT": "Dịch vụ khách hàng MT",
		"CJ": "Những vấn đề thường gặp",
		"contact_online": "liên hệ với dịch vụ khách hàng",
		"copy_wx": "Sao chép số WeChat",
		"copy_mt": "Sao chép số MT"
	},
	"msg_text": {
		"save_date": "Tin tức được lưu trữ tối đa một tháng",
		"message": "tin tức",
		"email": "bưu kiện",
		"receive": "Đã lĩnh",
		"overdue": "Đã quá hạn",
		"not_delete": "Không thể xóa, vui lòng lĩnh phần thưởng trước",
		"not_be_deleted": "Bưu kiện chưa lĩnh sẽ không bị xóa"
	},
	"basic_text": {
		"basic_title": "Thông tin cơ bản",
		"account": "Số tài khoản：",
		"nickname": "Tên nick：",
		"name": "Họ và tên：",
		"com_title": "Thông tin liên lạc",
		"qq": "QQ：",
		"wx": "WeChat：",
		"phone": "Điện thoại di dộng：",
		"email": "Hòm thư："
	},
	"baes_text": {
		"unit": "đồng",
		"view": "kiểm tra 》",
		"yes": "Đúng",
		"no": "Không",
		"update": "Cập nhật",
		"cancel": "Hủy bỏ",
		"mail_system": "Hệ thống mail",
		"connected": "Đang kết nối, hãy kiên nhẫn chờ đợi...",
		"coin": "vàng"
	},
	"pre_details_text": {
		"lxkf": "hãy liên hệ với chăm sóc khách hàng của chúng tôi",
		"rkz": "Đang nhập tiền...",
		"copy": "Sao chép",
		"order": "Số đơn đặt hàng",
		"date": "Thời gian nạp tiền",
		"czType": "cách thức nạp tiền",
		"transfer": "chuyển khoản",
		"succ": "thành công",
		"error": "thất bại",
		"audit": "đang xét duyệt",
		"czSucc": "Nạp tiền thất bại",
		"copy_succ": "sao chép thành công",
		"order_num": "Số đơn đặt hàng",
		"detail": "Chi tiết nạp tiền"
	},
	"USDT_text": {
		"second_step": "Bước 2: Thông tin chuỗi USDT",
		"url_name": "Tên chuỗi",
		"alipay": "Thanh toán bằng Alipay",
		"url": "Địa chỉ chuỗi..."
	},
	"set_text": {
		"set_music": "Cài đặt nhạc",
		"switch_music": "Chuyển đổi nhạc",
		"change_d_paw": "Sửa đổi mật khẩu đăng nhập",
		"change_t_paw": "Sửa đổi mật khẩu rút tiền",
		"version": "Phiên bản hiện tại",
		"huidu": "Bản độ xám",
		"swi_test": "Có phải chuyển đổi thành bản thử nghiệm？",
		"swi_hui": "Có phải chuyển đổi thành bản độ xám？",
		"old_paw_null": "Mật khẩu cũ không được để trống, vui lòng điền vào！",
		"new_paw_null": "Mật khẩu mới không được để trống, vui lòng điền vào！",
		"old_paw_limit_length": "Mật khẩu cũ là 6-12 chữ số",
		"new_paw_limit_length": "Mật khẩu mới là tổ hợp của 6-12 chữ số và chữ cái",
		"new_paw_limit": "Mật khẩu cũ phải có 6 chữ số, vui lòng điền lại",
		"con_paw_null": "Mật khẩu xác nhận không được để trống, vui lòng điền vào！",
		"con_paw_consistent": "Mật khẩu và mật khẩu xác nhận không nhất quán, vui lòng điền lại！",
		"new_old_paw_consistent": "Mật khẩu mới và mật khẩu cũ không được giống nhau, vui lòng điền lại！",
		"change_succ": "Chúc mừng bạn, đã thay đổi thành công mật khẩu, vui lòng đăng nhập lại！",
		"tx_paw_null": "Mật khẩu rút tiền không được để trống, vui lòng điền lại",
		"con_tx_paw": "Mật khẩu xác nhận rút tiền không được để trống, vui lòng điền lại",
		"tx_paw_consistent": "Mật khẩu rút tiền và mật khẩu xác nhận không nhất quán, vui lòng xác nhận",
		"tx_paw_limit": "Mật khẩu rút tiền phải có 6 chữ số, vui lòng điền lại",
		"paw_change_succ": "Chúc mừng bạn, đã thay đổi thành công mật khẩu",
		"latest_version": "Đây là App phiên bản mới nhất",
		"switch_server": "Chuyển đổi máy chủ",
		"switch_language": "Chuyển đổi ngôn ngữ",
		"change_language_tips": "Ngôn ngữ của một số trang sẽ có hiệu lực sau khi khởi động lại ứng dụng",
		"restart": "Khởi động lại"
	},
	"share_text": {
		"copy_wa": "Sao chép án văn",
		"save_img": "Lưu hình ảnh",
		"share_py": "chia sẻ lên tường",
		"submit_audit": "Gửi đánh giá",
		"copy_succ": "Sao chép thành công",
		"save_img_succ": "Lưu hình ảnh thành công",
		"save_err": "Lưu hình ảnh thất bại. Vui lòng đi đến trang cài đặt điện thoại, mở quyền lưu trữ hình ảnh của ứng dụng này",
		"share_go": "Chia sẻ đến：",
		"share_err_qq": "Chia sẻ thất bại，vui lòng thử lại sau khi cài đặt hoặc kiểm tra QQ",
		"share_err_wx": "Chia sẻ thất bại，vui lòng thử lại sau khi cài đặt hoặc kiểm tra Wechat",
		"share_err_wl": "Liên kết không thành công, vui lòng kiểm tra mạng rồi thử lại",
		"shareIntroduce_title": "Chia sẻ hướng dẫn",
		"inviteFriends": "mời bạn bè"
	},
	"hot_text": {
		"dzyx": "Hội tụ các game điện tử hấp dẫn toàn cầu  độ nóng không giảm  tỷ lệ thắng càng cao  hàng ngàn vạn quà tặng đang chờ bạn giành chiến thắng！",
		"qbyx": "Hội tụ các game chơi cờ chơi bài hấp dẫn toàn cầu  độ nóng không giảm  tỷ lệ thắng càng cao  hàng ngàn vạn quà tặng đang chờ bạn giành chiến thắng！",
		"byyx": "Hội tụ game đánh cá hấp dẫn toàn cầu  độ nóng không giảm  tỷ lệ thắng càng cao  hàng ngàn vạn quà tặng đang chờ bạn giành chiến thắng！",
		"rmdz": "Trò chơi",
		"rmqp": "Cờ vua phổ biến",
		"rmby": "Câu cá phổ biến",
		"ljyx": "Bắt đầu chơi"
	},
	"agent_text": {
		"my_id": "ID của tôi：",
		"under": "Tiền hoa hồng trực thuộc ngày hôm qua：",
		"offline": "tiền hoa hồng tuyến dưới ngày hôm qua：",
		"under_player": "Người chơi trực thuộc：",
		"day_new": "Tăng mới ngày hôm qua：",
		"offline_player": "Người chơi tuyến dưới：",
		"bind_wx": "Liên kết Wechat",
		"share_rewards": "phần thưởng chia sẻ ：",
		"commission_ins": "Ngày thanh toán tiền hoa hồng là thanh toán hàng ngày, chia sẻ cho bạn bè hoặc chia sẻ lên tường có thể nhận được phần thưởng chia sẻ！"
	},
	"vip_text": {
		"title": "Tên Truy CậpVIP",
		"backToMe": "Quay về trang chủ",
		"me": "Tên Truy Cập",
		"my_level": "Đẳng cấp của tôi：",
		"current_code": "Lượng đánh mã hiện tại：",
		"was_filed": "thăng cấp tuổi vàng ",
		"was_filed_info": "thăng cấp là có thể nhận được tuổi vàng",
		"weeks_amounts": "Quà tặng hàng tuần",
		"weeks_amounts_info": "Phát miễn phí vào thứ hai hàng tuần",
		"month_amounts": "Quà tặng hàng tháng",
		"month_amounts_info": "Phát đúng giờ vào ngày 1 hàng tháng",
		"wash_code": "Rửa mã",
		"wash_code_info": "Tỷ lệ rửa mã cao nhất",
		"but_text": "Đi ngay",
		"get_error": "Lĩnh tiền vàng thất bại, vui lòng làm mới lại tiền vàng！",
		"amount_code": "Số tiền đánh mã"
	},
	"xima_text": {
		"game_type": "Loại hình game",
		"dm_total": "đầu tư hiệu quả hơn",
		"proportion": "Tỷ lệ rửa mã cao nhất",
		"xm_amount": "Số tiền rửa mã",
		"can_led_take": " Có thể lĩnh",
		"xm_total": "Tổng số tiền rửa mã"
	},
	"PlayerCenter": {
		"jbxx": "Thông Tin Của Tôi",
		"zhmx": "Giao Dịch ",
		"zdlb": "Lịch Sử Cá Cược ",
		"my_vip": "Tên Truy CậpVIP",
		"save": "bảo tồn",
		"edit": "Chỉnh Sửa ",
		"note": "Ghi chú",
		"betting_record": "kỷ lục cá cược",
		"trading_hours": "thời gian giao dịch",
		"trading_type": "Loại giao dịch",
		"change_amount": "biến động số tiền",
		"balance": "Số dư",
		"today": "Hôm nay",
		"yesterday": "Hôm qua",
		"a_month": "Một tháng",
		"all": "Toàn bộ",
		"status": "Trạng thái giao dịch",
		"chess": "Cờ bài",
		"send_time": "thời gian trao tiền thưởng",
		"note_num": "game—Số cược",
		"betting_amount": "Số tiền đặt cược",
		"has_been": "Đã trao giải thưởng",
		"gaming": "Sân chơi game",
		"currencyType":"Chuyển tiền tệ",

	},
	"RechargeLayer": {
		"note": "Ghi chú",
		"often_play": "Số tiền nhanh mà người chơi thường chơi",
		"between": "Vui lòng nhập số tiền từ 1 ~ 100",
		"gift100": "Tặng 100%",
		"payment_account": "Tài khoản nhận tiền",
		"payee": "Người nhận tiền",
		"where": "Ngân hàng mở tài khoản",
		"depositors": "Vui lòng điền tên thật của người gửi tiền",
		"note_info": "Thông tin ghi chú",
		"step": "Bước 1: quét mã thanh toán QR  và tiến hành nạp tiền",
		"step2": "Bước 2: Điền thông tin nạp tiền của bạn, gửi nạp tiền",
		"session": "Hội thoại gần đây",
		"official": "Chứng nhận chính thức",
		"gift2": "Tặng2%",
		"channel": "*Vui lòng chọn kênh nạp tiền  n * trước khi chọn kênh, vui lòng kiểm tra tỷ giá hối đoái cẩn thận",
		"qr_code": "bảo\nlưu\nmã\nQR",
		"digital_currency": "Kênh 1 nạp tiền kỹ thuật số ",
		"step_1": "Bước 1: Chọn số tiền USDT",
		"formula": "Công thức tính toán của lần nạp tiền cuối cùng vào số tiền tài khoản：70.86=10.1234USDT*tỷ giá hối đoái hiện tại 7đồng",
		"step3": "Bước 3: Cung cấp thông tin rút tiền",
		"actual_account": "Số tiền USDT thực tế nhận được",
		"poundage": "Phí thủ tục 0-50USDT",
		"instr": "*Vui lòng điền đúng như trong hình bên trái!  n * nếu điền sai, sẽ không thể vào tài khoản đúng giờ！",
		"not_account": "Nạp tiền chưa vào tài khoản?",
		"rate": "Tỷ giá hối đoái：1USDT=99đồng",
		"prompt_info": "Thông tin nhắc nhở",
		"save_code": "Nhấn và giữ để lưu mã QR",
		"currency_symbol": "₫",
		"currency_word": "VND",
		"czjl": "Ghi lại tiền",
		"czjc": "Hướng dẫn nạp tiền",
		"ljcz": "Nạp tiền ngay",
		"czje": "Số tiền nạp",
		"zfpz": "Chứng từ thanh toán",
		"xuanchuan": "Nạp tiền cho đại lý chính thức\n        Đảm bảo uy tín tuyệt đối",
		"usdt_address": "Địa chỉ gửi USDT:",
		"syb": "Trước",
		"complete": "thực hiện",
		"usdt_num": "Gửi số tiền USDT:",
		"go_recharge": "Nạp tiền",
		"back": "trở về",
		"creat_order": "Tạo đơn hàng",
		"real_usdt": "Số USDT thực tế nhận được",
		"sxf": "Phí xử lý",
		"date": "thời gian",
		"state": "trạng thái",
		"jine": "Số tiền",
		"detail": "Chi tiết",
		"rechargeCourse": "Hướng dẫn nạp tiền",
		"rate2coin": "tỷ giá:1 đồng vàng = ",
		"get_coins": "Số tiền vàng nhận được:",
		"get_money": "Số tiền nhận được:",
        "go_pay": "Sao chép thành công. Bạn có muốn thanh toán ngay không?",
        "pay_now": "Thanh toan ngay",
        "pay_not_support": "Không thể thanh toán tạm thời!",
	},
	"SettingLayer": {
		"bind_equi": "Thiết bị liên kết",
		"basic_info": "Thông tin cơ bản",
		"account": "Số tài khoản：",
		"level": "Đẳng cấp：",
		"set_sound": "Cài đặt âm thanh",
		"music": "Âm nhạc",
		"sound": "Hiệu ứng âm thanh",
		"switch_music": "Chuyển đổi nhạc",
		"song2": "Chết rồi cũng vẫn yêu",
		"song1": "bài hát 1",
		"inp_landing_paw": "Vui lòng nhập mật khẩu đăng nhập",
		"inp_old_paw": "Vui lòng nhập mật khẩu cũ",
		"old_paw": "Mật khẩu cũ：",
		"inp_new_paw": "Vui lòng nhập mật khẩu mới",
		"new_paw": "Mật khẩu mới：",
		"con_new_paw": "Xác nhận mật khẩu mới",
		"con_paw": "Xác nhận mật khẩu：",
		"check_update": "Kiểm tra cập nhật",
		"determine": "Xác nhận",
		"bind_shuom1": "*Sau khi liên kết thiết bị, có thể sử dụng đăng nhập nhanh, đăng nhập trực tiếp thiết bị liên kết.",
		"bind_shuom2": "*Thông qua đăng ký tài khoản đăng nhập nhanh, tự động liên kết thiết bị hiện tại",
		"bind_shuom3": "*Sau khi liên kết thiết bị, có thể xác minh danh tính hủy liên kết",
		"bind_shuom4": "*Xác minh danh tính, yêu cầu nhập mật khẩu đăng nhập tài khoản.",
		"bind_shuom5": "*Vui lòng cẩn thận sử dụng ！",
		"bind_shuom6": "Đã liên kết thiết bị hiện tại",
		"bind_shuom7": "Đã liên kết thiết bị khác",
		"landing_paw": "Mật khẩu đăng nhập：",
		"test": "hoàn cảnh thử nghiệm",
		"huidu": "hoàn cảnh độ xám",
		"standbyTest": "hoàn cảnh thử nghiệm dự phòng",
		"mute_all": "Câm tất cả",
		"change_account": "Chuyển tài khoản",
		"confirm_change": "Xác nhận các thay đổi",
		"confirm_bind": "Ràng buộc thiết bị",
		"unbind_device": "Hủy liên kết thiết bị",
		"unbind": "Bỏ ràng buộc"
	},
	"Task": {
		"share_task": "Chia sẻ nhiệm vụ",
		"MG_electronic": "MG điện tử",
		"cash": "Tiền mặt",
		"complete": "Đi hoàn thành",
		"application": "Đang yêu cầu",
		"refused": "Đã từ chối",
		"disclose_data": "Gửi tài liệu",
		"submit": "Gửi đi",
		"Audit_failure": "Xét duyệt thất bại",
		"friends_account": "Gửi ảnh chụp màn hình",
		"apply_reward": "Xin phần thưởng",
		"pic_limit": "Chỉ có thể tải lên JPG、JPEG、PNG，không được vượt quá 1M",
		"update_pic": "Tải lên hình ảnh",
		"task_details": "Chi tiết nhiệm vụ",
		"Task_details": "Chi tiết nhiệm vụ：",
		"task_name": "Tên nhiệm vụ：",
		"task_state": "Mô tả nhiệm vụ：",
		"share": "Chia sẻ",
		"task_progress": "tiến độ nhiệm vụ：",
		"know": "Tôi biết rồi",
		"q_update_pic": "Vui lòng tải lên hình ảnh trước",
		"activit_Shut": "Hoạt động nhiệm vụ đã đóng",
		"Qbind_wx": "Vui lòng liên kết Wechat trước",
		"Application_success": "Yêu cầu thành công, vui lòng chờ xét duyệt",
		"Succ_application_Award": "Xin phần thưởng thành công",
		"task_ShutDown": "Nhiệm vụ chia sẻ đã đóng",
		"btn_choose": "lựa chọn",
		"editTips": "Vui lòng chọn hình ảnh đã tải lên"
	},
	"ThirdGamesListLayer": {
		"xsj": "Cờ bài thế giới mới",
		"tall_game": "Tổng cộng 1 game",
		"inp_game": "Vui lòng nhập tên game"
	},
	"TuiGuangLayer": {
		"title": "Quảng cáo kiếm tiền",
		"my_agent": "Đại lý của tôi",
		"agent_introduced": "Giới thiệt đại lý",
		"players_query": "Truy vấn người chơi",
		"results_query": "Truy vấn công trạng",
		"rich_list": "Bảng của cải",
		"my_id": "ID của tôi：",
		"under": "Tiền hoa hồng trực thuộc ngày hôm qua：",
		"offline": "tiền hoa hồng tuyến dưới ngày hôm qua：",
		"under_player": "Người chơi trực thuộc：",
		"day_new": "Tăng mới ngày hôm qua：",
		"offline_player": "Người chơi tuyến dưới：",
		"share_rewards": "phần thưởng chia sẻ ：",
		"commission_ins": "Ngày thanh toán tiền hoa hồng là thanh toán hàng ngày, chia sẻ cho bạn bè hoặc chia sẻ lên tường có thể nhận được phần thưởng chia sẻ！",
		"save_qr_code": "Lưu mã QR",
		"copy": "Sao chép",
		"bind_wx": "Liên kết Wechat",
		"Imm_receive": "Nhận ngay",
		"share_detail": "Chi tiết chia sẻ",
		"get_record": "Ghi chép nhận được",
		"zhishu_renshu": "số người trực thuộc：",
		"tall_bets_today": "Tổng các cược hữu hiệu ngày hôm nay：",
		"inp_id": "Vui lòng nhập ID",
		"query": "Truy vấn",
		"reset": "Cài lại",
		"bets_today": "Cá cược hữu hiệu ngày hôm nay",
		"total_bets": "Tổng các cược hữu hiệu",
		"directly_num": "Số người trực thuộc",
		"operation": "Thao tác",
		"details": "Chi tiết>>",
		"date": "Ngày tháng",
		"under_new": "Tăng thêm trực thuộc mới",
		"team_new": "Tăng thêm đội mới",
		"directly_under": "Hoàn lại tiền trực thuộc",
		"total_amount": "Tổng số tiền hoàn lại",
		"reward": "phần thưởng",
		"ranking": "Xếp hạng",
		"player_info": "Thông tin người chơi",
		"rebate_month": "Phần thưởng hoàn lại tiền tháng này",
		"rewards_month": "Phần thưởng chia sẻ tháng này",
		"detailed_info": "thông tin chi tiết",
		"zhuce_shijian": "Thời gian đăng ký：",
		"jtyxtz": "Cá cược hữu hiệu ngày hôm nay：",
		"tdrsxz": "Số người trong đội（mới tăng ）：",
		"jrtdyxtz": "Cá cược hữu hiệu của đội ngày hôm nay：",
		"directly_num_new": "số người trực thuộc (mới tăng)：",
		"zuoriyongjing": "Tiền hoa hồng ngày hôm qua：",
		"commission_payable": "Có thể rút tiền hoa hồng：",
		"lishizongyong": "Lịch sử tổng tiền hoa hồng：",
		"zyxtz": "Tổng các cược hữu hiệu",
		"agent_commission": "Tiền hoa hồng đại lý",
		"share_commission": "Tiền hoa hồng chia sẻ",
		"team_num": "Số người trong đội",
		"not_directly_under": "Hoàn lại tiền phi trực thuộc",
		"account": "Số tài khoản",
		"between": "Quan hệ",
		"effective_betting": "Cá cược hữu hiệu/Số tiền hoàn lại",
		"ratio": "Tỉ lệ hoàn tiền",
		"total": "Tổng cộng",
		"share": "Chia sẻ",
		"agent_recruit": "Tuyển dụng đại lý",
		"historyCom": "Tổng hoa hồng lịch sử",
		"canReceive": "Hoa hồng phải thu",
		"contact": "Liên hệ gia sư"
	},
	"WithdrawLayer": {
		"self_help": "rút tiền tự trợ",
		"withdrawal_record": "Lịch sử rút tiền",
		"wallet_management": "Quản lý ví tiền",
		"inp_withdrawal_amount": "Vui lòng nhập số tiền rút",
		"warm_prompt": "Lời khuyên",
		"current_need_adjust_amount": "Hiện tại còn cần <color=#00ff00>0</c> thu chi，mới có thể rút tiền",
		"current_need": "Hiện tại còn cần",
		"can_carry": "thu chi，mới có thể rút tiền",
		"adjust_amount": "Kéo các dấu chấm có thể điều chỉnh số tiền mặt rút",
		"bank": "Ngân hàng công thương",
		"change_bank_card": "Đổi thẻ ngân hàng",
		"not_bind_card": "Bạn tạm thời chưa liên kết thẻ ngân hàng, xin vui lòng chuyển đến liên kết",
		"not_tixian_paw": "Bạn chưa cài đặt mật khẩu rút tiền, vui lòng cài đặt mật khẩu rút tiền trước",
		"tixian_paw": "Mật khẩu rút tiền",
		"set6num_paw": "Vui lòng cài đặt mật khẩu gồm 6 chữ số",
		"confirm_password": "Mật khẩu xác nhận ",
		"again_confirm_password": "Vui lòng nhập lại mật khẩu lần nữa, để xác nhận",
		"inp_tixian_paw": "Vui lòng nhập mật khẩu rút tiền",
		"topUp_failure": "Nạp tiền thất bại",
		"bank_paragraph": "Rút tiền ngân hàng",
		"add_card": "Thêm thẻ ngân hàng",
		"cardholder_name": "Vui lòng nhập tên chủ thẻ ",
		"cardholder": "Chủ thẻ：",
		"card_code": "Tài khoản thẻ ngân hàng：",
		"inp_bank_card_code": "Vui lòng nhập số thẻ ngân hàng",
		"inp_bank_address": "Vui lòng nhập địa chỉ ngân hàng",
		"bank_address": "Địa chỉ mở tài khoản：",
		"bank_address_msg": "Nhắc nhở: vui lòng chọn chính xác ngân hàng mở tài khoản, và liên kết tên thật，khi thanh toán sẽ chuyển trực tiếp vào tài khoản này, vì sự an toàn tiền vốn của bạn, không được tùy ý thay đổi sau khi liên kết, nếu cần sửa đổi, vui lòng liên hệ với nhân viên chăm sóc khách hàng.",
		"choose_bank": "Lựa chọn ngân hàng：",
		"inp_aliPay_name": "Vui lòng nhập tên thật của Alipay",
		"inp_aliPay_code": "Vui lòng nhập tài khoản Alipay",
		"name": "Họ và tên：",
		"aliPay_account": "tài khoản Alipay：",
		"aliPay_account_msg": "Nhắc nhở: vui lòng chọn chính xác Alipay，khi thanh toán sẽ chuyển trực tiếp vào tài khoản này, vì sự an toàn tiền vốn của bạn, không được tùy ý thay đổi sau khi liên kết, nếu cần sửa đổi, vui lòng liên hệ với nhân viên chăm sóc khách hàng.",
		"inp_tixian_dizhi": "Vui lòng nhập địa chỉ rút tiền",
		"rate": "tỷ giá",
		"daozhangUSDT": "Số tiền USDT nhận được",
		"confirm_tixian": "Xác nhận rút tiền",
		"max": "tối đa",
		"confirm_submit": "Xác nhận gửi",
		"tixian_time": "Thời gian rút tiền",
		"jine": "Số tiền",
		"state": "trạng thái",
		"order_info": "thông tin đặt hàng",
		"confirm_bind": "Xác định ràng buộc",
		"confirm_select": "Xác nhận lựa chọn",
		"select_bank_card": "Chọn thẻ ngân hàng",
		"bizhong_xuanze": "Lựa chọn tiền tệ:",
		"tixian_dizhi": "Địa chỉ rút tiền:",
		"more_than_0": "Số tiền rút phải lớn hơn 0"
	},
	"XimaLayer": {
		"selfHelp_washing": "Rửa mã tự trợ",
		"xima_record": "Ghi chép rửa mã",
		"xima_proportion": "Tỷ lệ rửa mã ",
		"fishing_game": "Game đánh cá",
		"to_complete": "Đi hoàn thành",
		"receive": "Lĩnh",
		"chess": "Cờ bài",
		"fishing": "Đánh cá",
		"electronic": "điện tử",
		"reality": "Người thật",
		"sports": "thể thao",
		"eSports": "Trò chơi thể thao điện tử",
		"lottery": "Xổ số",
		"game": "game",
		"key_get": "Lĩnh một phát",
		"get_time": "Thời gian lĩnh",
		"damaliang": "đầu tư hiệu quả hơn",
		"xima_amount": "Số tiền rửa mã",
		"details": "Chi tiết",
		"viewI": "Kiểm tra>>",
		"xima_details": "Chi tiết rửa tiền",
		"heitao_chess": "Cờ bài Đào Đen",
		"chess_game": "Game cờ bài",
		"sports_events": "cuộc thi đấu thể thao",
		"electronic_game": "điện tử giải trí",
		"lottery_betting": "Đặt cược xổ số",
		"real_video": "Video người thật",
		"eSports_game": "Trò chơi thể thao điện tử",
		"game_name": "Tên trò chơi",
		"click_details": "Bấm vào để xem chi tiết",
		"tianmei_chess": "Cờ bài Thiên Mỹ",
		"detailsI": "Chi tiết>>",
		"xima_range": "Phạm vi rửa mã",
		"vip_level": "Đẳng cấp Vip",
		"tournament": "Cuộc thi đấu trò chơi thể thao điện tử",
		"lottery_game": "Trò chơi xổ số",
		"title": "Mã rửa"
	},
	"Signal": {
		"switch": "Chuyển đổi tuyến",
		"speed": "Tuyến tăng tốc",
		"choose": "Chọn tuyến",
		"reconnect": "Kết nối lại",
		"helpful_hints": "Nhắc nhở thân thiện: độ trễ càng thấp, mạng càng tốt",
		"is_msg": "Đây là một tin nhắn",
		"in_test": "Đang kiểm tra",
		"general": "thường",
		"smooth": "Lưu loát",
		"speed1": "cấp tốc",
		"current_use": "Hiện đang sử dụng"
	},
	"general": {
		"name": "Họ và tên",
		"activity": "Hoạt động tổng hợp",
		"xzsm": "Bộ phát địa chỉ, nhận địa chỉ cài đặt mới nhất bất cứ lúc nào",
		"wszl": "Hoàn thiện tài liệu",
		"qdcj": "Tiền vàng điểm danh",
		"xtyj": "Hệ thống bưu kiện",
		"xxzx": "Trung tâm tin tức",
		"bt": "Tiêu đề",
		"sj": "Thời gian",
		"nr": "Nộ dung",
		"xx": "Tin tức",
		"ready_all": "toàn bộ đã đọc",
		"dlq": "Đang chờ xử lý",
		"ylq": "Nhận",
		"ygq": "hết hạn",
		"del_all": "xóa hết",
		"get_all": "Yêu cầu tất cả"
	},
	"EllipticalStage": {
		"musicNmae": "Để chiến thắng"
	},
	"CheckHot": {
		"update_msg": "Một bản cập nhật phiên bản mới được phát hiện, đã tải xuống hoàn tất cho bạn, nhấp để có thể hoàn tất cập nhật！",
		"update": "Cập nhật",
		"lack_resources": "Thiếu dữ liệu nghệ thuật",
		"kaiyuan_chess": "Cờ bài Khai Nguyên",
		"leyou_chess": "Cờ bài Lạc Du",
		"xinshijie_chess": "Cờ bài thế giới mới",
		"ag_electronic": "AG điện tử",
		"pg_electronic": "PG điện tử",
		"mg_electronic": "MG điện tử"
	},
	"HallUI": {
		"copy_succ": "Sao chép thành công",
		"moment_open": "Tạm thời chưa mở",
		"no_announcement": "Tạm thời không có nội dung thông báo",
		"tmpled_err": "Lỗi cấu hình mẫu, vui lòng liên hệ với dịch vụ khách hàng",
		"game_maintain": "Trò chơi đang được bảo trì",
		"game_loading": "Trò chơi đang tải",
		"get_err": "Không thể lấy được tiền vàng, vui lòng làm mới lại tiền vàng！",
		"login": " Đăng Nhập ",
		"register": "Đăng ký",
		"copy_id": "Sao chép ID",
		"buyu": " Bắn cá",
		"zhenren": "CASINO Trực Tiếp",
		"dianzi": " TRÒ CHƠI",
		"tiyu": "Thể thao",
		"caipiao": " xổ số",
		"tuiguangdaili": "Quảng cáo kiếm tiền",
		"xiaoxi": "Hộp Thư Đến ",
		"kefu": "Hỗ Trợ",
		"chongzhi": "Gửi Tiền",
		"remenyouxi": "Trò Chơi Mới",
		"zuijingchangwan": "TRÒ CHƠI",
		"huodong": "Hoạt động",
		"task": "bài tập",
		"setting": "Thiết lập",
		"remen": "Phổ biến",
		"qipai": "Cờ vua",
		"dianjing": "Chơi game",
		"xima": "hoàn trả",
		"xiufugongju": "Công cụ sửa chữa",
		"gengduo": "Hơn",
		"qiandao": "Đăng nhập",
		"paihangbang": "Bảng xếp hạng",
		"gonggao": "sự thông báo",
		"tixian": "rút tiền",
		"xianshilingqu": "Bộ sưu tập thời gian có hạn",
		"play_now": "Cá cược"
	},
	"BasicsJS": {
		"tall": "Tổng cộng",
		"minGame": "Trò chơi nhỏ",
		"play_game": "Không có trò chơi nào gần đây",
		"editor_succ": "Chỉnh sửa thành công",
		"yi_bind": "Đã liên kết",
		"wu_bind": "Chưa liên kết",
		"inp_amount": "Vui lòng nhập số tiền nạp",
		"inp_correct_amount": "Vui lòng nhập số tiền nạp chính xác ",
		"no_login_yinshang": "Chưa đăng nhập ngân hàng ",
		"gift": "Tặng",
		"voucher_cannot_empty": "Chứng từ thanh toán không được để trống",
		"pic_loading": "Hình ảnh đang tải",
		"amount_between": "Số tiền giữa",
		"card": "Thẻ",
		"note_info": "Điền thông tin ghi chú, tiền càng nhanh vào tài khoản",
		"credit_cord": "Số thẻ nhận",
		"rate": "Tỷ giá hối đoái",
		"not_channel": "Kênh nạp tiền không tồn tại, vui lòng liên hệ với dịch vụ khách hàng",
		"select_amount": "Vui lòng chọn số tiền nạp",
		"confirm_cancellation_order": "Chắc chắn hủy đơn hàng không",
		"been_submit": "Đơn hàng đã được gửi, vui lòng kiên nhẫn chờ đợi",
		"Eventually_topUp_amount": "Số tiền nạp cuối cùng nhận được là",
		"current_rate": "Tỷ giá hiện tại",
		"Outstanding_orders": "Bạn có đơn hàng chưa hoàn thành, có muốn tiếp tục",
		"Continue": "Tiếp tục",
		"Cancel_order": "Hủy đơn hàng",
		"bind_succ": "Liên kết thành công",
		"inp_paw": "Vui lòng nhập mật khẩu trước",
		"remove_bind_succ": "Hủy liên kết thành công",
		"first": "Đầu tiên",
		"day": "Ngày",
		"Sports_eSports": "Trò chơi thể thao điện tử",
		"directly": "Trực thuộc",
		"not_directly": "Phi trực thuộc",
		"amount_not_null": "Số tiền rút không được để trống, vui lòng điền vào",
		"WithdrawalAmount": "Số tiền rút",
		"Qbind": "Vui lòng liên kết trước",
		"moment_not_bind": "Bạn tạm thời chưa liên kết",
		"QgoBind": "Vui lòng đi đến liên kết",
		"replace": "Cập nhật",
		"between": "Giữa",
		"request_submit": "Yêu cầu rút tiền đã được gửi",
		"ContinueToCarry": "Tiếp tục rút tiền",
		"GiveUpWithdrawal": "Thoát khỏi rút tiền",
		"Qxuanding": "Nhắc nhở: vui lòng chọn chính xác",
		"jiesuanshihou": "khi thanh toán sẽ được chuyển trực tiếp đến đây",
		"zhuanghaowanquan": "Tài khoản, vì sự an toàn tiền vốn của bạn, không được tùy ý thay đổi sau khi liên kết. Nếu bạn cần sửa đổi, vui lòng liên hệ với nhân viên chăm sóc khách hàng.",
		"phoneNo": "Số điện thoại",
		"add": "Thêm vào",
		"updateTimeout": "Kiểm tra quá thời gian cập nhật, vui lòng xác nhận xem mạng của bạn có bình thường không",
		"retry": "Thử lại",
		"err_retry": "Lỗi tải xuống tệp, vui lòng thử lại",
		"err_check_network": "Không thể tải xuống tệp, vui lòng xác nhận xem mạng của bạn có bình thường không",
		"no_get_data": "Không có cập nhật dữ liệu nào, vui lòng thử lại sau",
		"network_retry": "Mạng bị ngắt kết nối, vui lòng kiểm tra xem kết nối mạng của bạn có bình thường không",
		"Quit_game": "Thoát khỏi game",
		"ReturnHall": "Quay trở lại sảnh",
		"daozhangUSDT": "Nhận được số tiền USDT"
	}
};
